import Amount from './src/main'

Amount.install = function (Vue) {
  Vue.component(Amount.name, Amount)
}

export default Amount
